var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.authLoading)?_c('span',[_vm._v("loading-state")]):_vm._e(),(_vm.subscribed)?_c('span',[_vm._v("Текущий план")]):_c('router-link',{attrs:{"to":("/payment/" + (this.planId))}},[_vm._v("Выбрать план")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }